<div class=" card5 shadow flex ">

    <div class="p-1 custom-input-container line2">
        <i class="me-2" data-feather="dollar-sign" [size]="20"></i>
        <h5 class=" mb-0 size18">Grille tarifiare</h5>

    </div>

    <div>
        <table class=" table-responsive">
            <tbody>
            <tr>
                <th>Prix de vente</th>
                <td>{{ productData.result_ttc }} TND (TTC) <br><br>{{ productData.result_ht }} TND (HT)</td>

            </tr>
            <tr>
                <th>{{ prixLibelle }}</th>

                <td>{{ productData.liste_prix?.[0]?.result_ttc || '—' }} TND (TTC) <br><br>{{ productData.liste_prix?.[0]?.result_ht || '—' }} TND (HT)</td>
            </tr>
            <tr>
                <th>TVA</th>
                <td> {{productData.tva?.valeur}} %</td>
            </tr>
            <tr>
                <th>Taxes</th>
                <td> 
                    <span *ngIf="productData.taxes && productData.taxes.length > 0">
                        {{ getTaxesNames() }}
                    </span>
                    <span *ngIf="!productData.taxes || productData.taxes.length === 0">
                        --
                    </span>
                </td>
            </tr>

            </tbody>
        </table>
    </div>

</div>
